<template>
	<div class="space-y-5">
		<div class="text-start text-ihh-slate-gray font-normal text-sm md2:text-lg font-semibold italic">
			Due to a nationwide shortage of mini liners we are unable to offer the 5-pack and 10-pack quantity at this time. We are very sorry for the inconvenience. We expect
			to be restocked by early July at this time.
		</div>
		<div class="w-full text-start text-ihh-midnight-gray text-2xl sm:text-4xl font-semibold tracking-wide">Substitutes Available:</div>
		<div class="text-start font-normal text-sm md2:text-description">
			<ul class="list-disc ml-6 space-y-1 text-ihh-slate-gray">
				<li><a href="#" class="text-ihh-dark-salmon underline">Standard Generic Liner</a></li>
				<li><a href="#" class="text-ihh-dark-salmon underline">Small Oasis Generic Liner</a></li>
			</ul>
		</div>
		<div class="w-full text-start text-ihh-midnight-gray text-2xl sm:text-4xl font-semibold tracking-wide">
			Liner for Mini Size Birth Pool in a Box Personal and Professional Pools
		</div>
		<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description">
			Enhance your water birth experience with this custom liner for the MINI Size Birth Pool in a Box Personal and Professional Pools. Specifically tailored to fit the
			MINI version of Birth Pool in a Box Pools, this liner guarantees a seamless and secure fit, ensuring optimal functionality and peace of mind.
		</div>
		<div class="w-full text-start text-ihh-midnight-gray text-xl md2:text-2xl font-semibold md2:font-bold tracking-wide">Superior Quality and Design</div>
		<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description">
			Our MINI liners are crafted using 0.20mm Eco PVC, a premium material that combines durability and safety. This liner is free of Cadmium, Lead, and Latex,
			prioritizing the well-being of both the mother and baby.
		</div>
		<div class="w-full text-start text-ihh-midnight-gray text-2xl sm:text-4xl font-semibold tracking-wide">Features:</div>
		<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description">
			<ul class="list-disc ml-6 space-y-1">
				<li>
					Custom Fit: Designed to perfectly align with the handles and cupholder of the MINI version of Birth Pool in a Box Pools, ensuring a snug and secure fit.
				</li>
				<li>Disposable and Convenient: The liner is intended for one-time use, providing a hygienic solution without the hassle of cleaning and maintenance.</li>
				<li>Each liner comes with detailed instructions, guiding you through the simple and efficient installation process.</li>
				<li>
					Easy to Use: The liner is conveniently folded flat, allowing for easy storage and transport. If the liner arrives cold, we recommend allowing it to warm to
					room temperature before unfolding for the best results.
				</li>
				<li>
					Bulk Discounts Available: For your convenience and savings, the liner is also available in packs of 5 or cases of 10 at a discounted price, ensuring you
					have an ample supply for multiple uses or professional settings.
				</li>
				<li>
					Essential for Warranty: To qualify for the warranty provided by Birth Pool in a Box, the use of the custom liner is required. Ensure your pool's longevity
					and coverage by utilizing the designated liner.
				</li>
				<li>
					Safe Temperature Limit: Please note that the hot water temperature limit for the Birth Pool in a Box liner is 122 degrees Fahrenheit (50 degrees Celsius).
					Adhering to this temperature range ensures a safe and comfortable experience for both mother and baby.
				</li>
			</ul>
		</div>
		<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description">
			<span class="font-semibold">Important Note:</span> To ensure you are ordering the correct size for your water birth pool, please verify the pool size and select
			the MINI liner accordingly. The Regular size liner is available <a href="#" class="text-ihh-dark-salmon underline">here</a>.
		</div>
	</div>
</template>
